<template>
  <div class="message-icon">
    <svg-loader
      v-if="group"
      :title="group.label"
      :src="'/static/images/icon-notification-' + group.icon + '.svg'"
    />
  </div>
</template>

<script>
import strings from '@/strings'

export default {
  name: 'Icon',
  props: {
    team: {
      type: String,
      default: 'P'
    }
  },
  data: () => {
    return {
      types: strings.notificationTypes
    }
  },
  computed: {
    group: function () {
      if (this.team) {
        return this.types.filter(options => options.value === this.team)[0]
      } else {
        return this.types.filter(options => options.value === 'P')[0]
      }
    }
  }
}
</script>

<style lang="scss">
.message-icon {
  display: flex;
  width: 10%;
  background: rgba(0, 0, 0, 0);

  .md-icon {
    width: 1.5em;
    height: 1.5em;
    z-index: 11032;
    margin-top: 30px;
    margin-right: -20px;
  }
}
</style>
